import keyMirror from 'keymirror';

export const INSTAGRAM_LAYOUT_STYLES = keyMirror({
  MASONRY: null,
  GRID: null
});

export const DEVICE_TYPE = {
  TABLET: 'tablet',
  MOBILE: 'mobile'
};
